import { useEffect, useState } from 'react'

import { DataBinary, dataBinaryToUrl } from '../utils/dataBinaryToUrl'

export function DataBinaryImage({
  dataBinary,
  alt,
  className,
  placeholderImage,
}: {
  dataBinary: DataBinary
  alt?: string
  className?: string
  placeholderImage?: string
}) {
  const [src, setSrc] = useState<string | undefined>(undefined)
  useEffect(() => {
    dataBinaryToUrl(dataBinary).then(({ url }) => setSrc(url))
  }, [dataBinary])

  if (!src && !placeholderImage) return null

  return (
    <img src={src || placeholderImage} alt={alt ?? ''} className={className} />
  )
}
